import {useCallback, useEffect, useState} from 'react';
import {OptionsDropdown} from '~/components/elements';
import {SKI_TEST_SORT_CONFIGS, SKI_TEST_SORT_KEYS} from '~/lib/const';
import {useNavigate} from '@shopify/hydrogen';
import {useRouter} from '@shopify/hydrogen/foundation/Router/BrowserRouter.client';

const sortOptionKeys = [
  SKI_TEST_SORT_KEYS.SKI_NAME_A_Z,
  SKI_TEST_SORT_KEYS.SKI_NAME_Z_A,
  SKI_TEST_SORT_KEYS.PRICE_LOW_HIGH,
  SKI_TEST_SORT_KEYS.PRICE_HIGH_LOW,
];

const sortOptionKeysOldSkiTests = [
  SKI_TEST_SORT_KEYS.SKI_NAME_A_Z,
  SKI_TEST_SORT_KEYS.SKI_NAME_Z_A,
];

const defaultSortBy = 'Sort By...';

export default function SkiTestSortDropdown({year}: {year: number}) {
  const navigate = useNavigate();
  const router = useRouter();
  const [sort, setSort] = useState<string | undefined>(undefined);
  const value = SKI_TEST_SORT_CONFIGS[sort ?? '']?.label ?? defaultSortBy;

  const handleChangeSort = useCallback(
    (name: string, value: string) => {
      const searchParams = new URLSearchParams(window.location.search);

      if (value === defaultSortBy) {
        searchParams.delete('sort');
        navigate(location.pathname + `?${searchParams.toString()}`, {
          replace: true,
          scroll: false,
        });
        return;
      }

      const [key] =
        Object.entries(SKI_TEST_SORT_CONFIGS).find(([k, v]) => {
          return value === v.label;
        }) ?? [];

      if (key == null) {
        console.error(`Unknown sort option ${value}`);
        return;
      }

      searchParams.set(name, key);
      navigate(location.pathname + `?${searchParams.toString()}`, {
        replace: true,
        scroll: false,
      });
    },
    [navigate],
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(router.location.search);
    const sort = searchParams.get('sort') ?? undefined;
    setSort(sort);
  }, [router.location.search]);

  const sortKeys = year < 2021 ? sortOptionKeysOldSkiTests : sortOptionKeys;

  return (
    <OptionsDropdown
      name={'sort'}
      selectedValue={value}
      values={[
        'Sort By...',
        ...sortKeys.map((key) => SKI_TEST_SORT_CONFIGS[key].label),
      ]}
      sortDisabled
      onChange={handleChangeSort}
    />
  );
}
